module.exports = new __parcel__URL__("wood-floor.ef0b798a.webp").toString();